import { TreeFolder } from '../util/document-list-to-tree';

interface FolderToggleProps {
  contentHeight: number;
  accordionRef: React.RefObject<HTMLDivElement>;
  isOpen: boolean;
  renderSubCategories: (subCategories: TreeFolder[]) => React.ReactNode;
  subCategories: TreeFolder[];
  /**
   * Ref to the actual content wrapper whose size can change
   * while open due to nested accordions expanding/collapsing
   */
  contentRef?: React.RefObject<HTMLDivElement>;
}

/**
 * FolderToggle component that handles the expandable content area
 *
 * @param props - Component props for folder toggle functionality
 * @returns Rendered expandable content area with smooth animations
 */
export const FolderToggle = ({
  contentHeight,
  accordionRef,
  isOpen,
  renderSubCategories,
  subCategories,
  contentRef,
}: FolderToggleProps) => {
  return (
    <div
      ref={accordionRef}
      className="overflow-hidden bg-day-light-5 transition-all duration-50 ease-out px-2"
      style={{
        height: isOpen ? `${contentHeight}px` : '0px',
      }}
      aria-expanded={isOpen}
      aria-hidden={!isOpen}
    >
      {isOpen && <div ref={contentRef}>{renderSubCategories(subCategories)}</div>}
    </div>
  );
};
